import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from '../../globals';
import { AuthServiceService } from '../../services/auth-service.service';
import { LoaderService } from '../../services/loader.service';
import { RegUser } from '../basic-reg/RegUser';
import moment from 'moment';
import { NgxIntlTelInputModule, SearchCountryField, CountryISO, PhoneNumberFormat} from 'ngx-intl-tel-input';
import { CommonUtil } from '../../util/CommonUtil';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    MatTooltipModule,
    HeaderComponent,
    FooterComponent,
    IonicModule,
    NgxIntlTelInputModule
  ]
})
export class LoginComponent implements OnInit {
    // signUpForm and userForm are defined below with correct types
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  userForm: RegUser = new RegUser();
  signUpForm: FormGroup = new FormGroup({});
  submitted: boolean = false;
  errorMessage: string = '';

  emailAlreadyExist: boolean = false;
  emailMessage: string = '';

  passwordVisible: boolean = false;

  emailPattern = '^[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}';
  requestPath: string;

  dob: NgbDateStruct = { year: 2000, month: 1, day: 1 };
  dateValidation: boolean = false;

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  redirectUrl: string = '';

  separateDialCode = false;
  preferredCountries = ['us', 'in'];

  isMobileLoginEnabled = false;

  constructor(
    @Inject(Globals) public global: Globals,
    @Inject(AuthServiceService) public authService: AuthServiceService,
    public formBuilder: FormBuilder,
    public router: Router,
    @Inject(LoaderService) private loader: LoaderService,
    @Inject(MenuController) private menuCtrl: MenuController,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.requestPath = this.global.requestPath;

    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params['redirectUrl'];
      this.errorMessage = params['msg'];
      // console.log(this.errorMessage);
    });
  }

  ngOnInit(): void {
    this.signUpForm = this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(this.emailPattern)]],
      userPassword: ['', [Validators.required, Validators.minLength(6)]],
      phoneNumber: ['', [Validators.required, this.noWhitespace]]
    });
  }

  public noWhitespace(control: any) {
    let isWhitespace = (control.value || '').toString().trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'required': true }
  }

  ionViewDidEnter() {
    this.initUser();
    this.onReset();
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

  initUser = () => {
    this.signUpForm.reset();
    this.userForm = new RegUser();
  }

  // convenience getter for easy access to form fields
  get f() { return this.signUpForm.controls; }

  public login() {
    this.submitted = true;
    this.errorMessage = '';

    // stop here if form is invalid
    // if (this.signUpForm.invalid) {
    //   // console.log("Invalid: " + this.signUpForm.value);
    //   return;
    // }
  // Removed duplicate/incorrect onSubmit arrow function assignment


    if (this.signUpForm.controls["userPassword"].status == "INVALID") {
      return;
    }

    if (this.isMobileLoginEnabled && this.signUpForm.controls["phoneNumber"].status == "INVALID") {
      return;
    }

    if (!this.isMobileLoginEnabled && this.signUpForm.controls["emailAddress"].status == "INVALID") {
      return;
    }

    this.userForm.phoneDialCode = this.userForm.phoneNumberAll?.dialCode;
    this.userForm.phoneCountryShortName = this.userForm.phoneNumberAll?.countryCode;
    this.userForm.phoneNumber = this.userForm.phoneNumberAll?.e164Number.replace(this.userForm.phoneNumberAll?.dialCode, "");

    this.loader.show("Please wait...");
    this.authService.loginOld(this.userForm.emailAddress, this.userForm.phoneNumber, this.userForm.userPassword)
      .subscribe(res => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {

          if (environment.isSubscriptionRequired && (res as any).statusCode == 1001) {
            // Subscription expired
            this.global.saveLocalData(this.global.SUBSCRIPTION, JSON.stringify(true));
          } else {
            this.global.saveLocalData(this.global.SUBSCRIPTION, JSON.stringify(false));
          }

          (res as any).data = this.global.decryptDefault((res as any).data);
          this.global.saveLocalData(this.global.HIDDIN_TOKEN, JSON.stringify((res as any).data.access_token));
          this.global.saveLocalData(this.global.BOGUS_KEY, JSON.stringify((res as any).data.key));
          // console.log('Successfully Logged-In');
          this.getMyProfile();
          this.onReset();
          this.initUser();
        } else {
          this.errorMessage = (res as any).message;
          this.cdr.detectChanges();
        }
      }, error => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  getMyProfile = () => {
    this.loader.show("Fetching user details...");
    this.authService.get('user?' + this.requestPath + '=getLoginUserDetail')
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if (res.success) {
          this.user = this.global.decryptDefault(res.data);
          this.user.birthDate = moment(this.user.birthDate, "MM/DD/YYYY").format("MM/DD/YYYY");
          this.global.saveLocalData(this.global.HIDDIN_USER_DETAILS, JSON.stringify(this.user));
          this.getImageUrl();
        } else {
          // console.log(res.message);
          this.errorMessage = res.message;
          this.cdr.detectChanges();
        }
      }, (error: any) => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Error occured";
        this.cdr.detectChanges();
      });
  }

  getImageUrl = () => {
    this.loader.show("Please wait...");
    this.authService.get('image?' + this.requestPath + '=getImage&type=profilepic')
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if (res.success) {
          res.data = this.global.decrypt(res.data);
          if (!this.global.isEmpty(res.data)) {
            this.global.saveLocalData(this.global.USER_IMAGE_URL, JSON.parse(res.data).imageUrl);
          }
        } else {
          this.errorMessage = res.message;
          this.cdr.detectChanges();
        }
        if (!this.global.isEmpty(this.redirectUrl)) {
          window.location.href = this.redirectUrl;
        } else {
          this.router.navigate(['/dashboard']);
        }
      }, (error: any) => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Error occured, please try again.";
        this.cdr.detectChanges();
      });
  }

  onReset = () => {
    this.submitted = false;
    this.signUpForm.reset();
    // this.errorMessage = null;
    this.isMobileLoginEnabled = false;
  }

  togglePassword(id: string) {
    const password = document.querySelector('#' + id);
    if (password) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
    }

    this.passwordVisible = !this.passwordVisible;


  }

  toggleLoginMethod() {
    this.isMobileLoginEnabled = !this.isMobileLoginEnabled;
    
    // Reset form validation state
    this.submitted = false;
    
    // Clear validation errors for both fields
    if (this.isMobileLoginEnabled) {
      this.signUpForm.controls['emailAddress'].clearValidators();
      this.signUpForm.controls['emailAddress'].reset();
      this.signUpForm.controls['phoneNumber'].setValidators([Validators.required, this.noWhitespace]);
    } else {
      this.signUpForm.controls['phoneNumber'].clearValidators();
      this.signUpForm.controls['phoneNumber'].reset();
      this.signUpForm.controls['emailAddress'].setValidators([Validators.required, Validators.maxLength(50), Validators.pattern(this.emailPattern)]);
    }
    
    // Update validation
    this.signUpForm.controls['emailAddress'].updateValueAndValidity();
    this.signUpForm.controls['phoneNumber'].updateValueAndValidity();
  }

}
